<template>
  <div class="header-wrapper row m-0" :class="{ 'header-wrapper-mobile': mobileCompact }">
    <SearchBar v-if="!mobileCompact" />
    <Logo v-if="!mobileCompact"/>
    <div class="nav-right col-12 pull-right right-header p-0 ms-auto" :class="{ 'nav-right-mobile': mobileCompact }">
      <div class="header-left-actions">
        <RfcSelector />
        <div v-if="showGlobalPeriodSelector" class="header-global-period-nav">
          <GlobalPeriodSelector />
        </div>
      </div>
      <ul class="nav-menus" :class="{ 'nav-menus-mobile': mobileCompact }">
        <TaxStatusCertificate />
        <ComplianceOpinion />
        <Notifications />
        <PendingDownloads />
        <Profile />
      </ul>
    </div>
  </div>
</template>
<script>
  import RfcSelector from './rfcSelector.vue';
  import TaxStatusCertificate from './taxStatusCertificate.vue';
  import ComplianceOpinion from './complianceOpinion.vue';
  import PendingDownloads from './pendingDownloads.vue';
  import Notifications from './notifications.vue';
  import Profile from './profile';
  import Logo from './logo.vue';
  import GlobalPeriodSelector from '@/components/global/GlobalPeriodSelector.vue';
  
  export default {
    props: {
      mobileCompact: { type: Boolean, default: false },
    },
    components: {
      RfcSelector,
      TaxStatusCertificate,
      ComplianceOpinion,
      PendingDownloads,
      Notifications,
      Profile,
      Logo,
      GlobalPeriodSelector,
    },
    computed: {
      showGlobalPeriodSelector() {
        return this.$route?.meta?.hideGlobalPeriod !== true;
      },
    },
    data() {
      return {};
    },
  };
</script>

<style scoped>
.header-wrapper {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.nav-right.right-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 12px;
}

.header-global-period-nav {
  min-width: 200px;
}

.nav-right.right-header > .nav-menus {
  margin-left: auto;
}

.header-wrapper-mobile {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.header-wrapper-mobile .nav-right-mobile {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.header-wrapper-mobile .header-left-actions {
  width: auto;
  flex-wrap: nowrap;
  gap: 8px;
  margin-right: 0;
  flex: 0 0 auto;
}

.header-wrapper-mobile .header-global-period-nav {
  min-width: 158px;
  width: auto;
}

.header-wrapper-mobile .nav-menus-mobile {
  margin-left: 0;
  width: auto;
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  flex: 0 0 auto;
}

.header-wrapper-mobile :deep(.header-rfc-trigger-card),
.header-wrapper-mobile :deep(.profile-trigger-card) {
  min-height: 44px;
  border-radius: 10px;
}

.header-wrapper-mobile :deep(.global-period-selector.is-header) {
  --gps-width: 158px !important;
  --gps-control-height: 44px !important;
}

.header-wrapper-mobile :deep(.header-action-btn) {
  width: 40px;
  height: 40px;
  border-radius: 10px;
}
</style>
